import { render, staticRenderFns } from "./autocomplete-field.vue?vue&type=template&id=22aa9562&scoped=true"
import script from "./autocomplete-field.ts?vue&type=script&lang=ts&external"
export * from "./autocomplete-field.ts?vue&type=script&lang=ts&external"
import style0 from "./autocomplete-field.scss?vue&type=style&index=0&id=22aa9562&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa9562",
  null
  
)

export default component.exports